import './LoadingScreen.scss'

export default function LoadingScreen() {
    return (
        <div className="loading-screen">
            <p className="loading-screen__spinner">Wczytywanie...</p>
        </div>
    )
}